import CONFIG from './config';


export default CONFIG;
// export {};